define('views/content/checkout',['require','backbone','marionette','collections/credit_cards','views/components/credit_card/credit_cards','models/purchase','models/recurring_purchase','views/components/installment_options/installment_options','models/wallet','text!templates/content/checkout.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');

    var CreditCardsCollection = require('collections/credit_cards');
    var CreditCardsView = require('views/components/credit_card/credit_cards');
    var PurchaseModel = require('models/purchase');
    var RecurringPurchaseModel = require('models/recurring_purchase');
    var InstallmentOptionsView = require('views/components/installment_options/installment_options');
    var WalletModel = require('models/wallet');

    var temp = require("text!templates/content/checkout.html");
    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'checkout-page',
        titleKey: 'checkout',

        initialize: function () {
            _.bindAll(this, 'render');
            App.context.changePageTitle(App.polyglot.t(this.titleKey));

            this.totalPrice = App.context.basket.get('products').reduce( function(total, currentProduct){
                if (currentProduct.product.exchange_currency == 3) {
                    // Product price in TRY
                    var dollar_try = parseFloat(App.context.constants.dollar_try);
                    return total + ((currentProduct.product.effective_price / dollar_try) * currentProduct.count);
                }

                return total + currentProduct.product.effective_price * currentProduct.count;
            }, 0);

            var regularProducts = [];
            var  recurringProducts  = [];

            var basketProducts = App.context.basket.get('products');


            basketProducts.forEach(function({count, product, license}){

                var newItem = {product:product.id, license, count};
                if (product.is_recurring){
                    recurringProducts.push(newItem);
                }else{
                    regularProducts.push(newItem);
                }
            });



            this.regularProducts = regularProducts;
            this.recurringProducts = recurringProducts;

           

            App.context.hasBasketRecurringProduct = recurringProducts.length > 0;

            
            this.regularPurchaseCompleted = true;
            this.recurringPurchaseCompleted = true;

            this.wallet = new WalletModel();

            this.tdsCheckOption = false;

            this.installmentOptionsView = new InstallmentOptionsView();
            
            var _this = this;
            this.wallet.fetch({
                success: function (res) {
                    var _wallet = res.attributes;
                    var currency = App.utils.getPaymentCurrency();
                    if (_wallet.currency == currency) {
                        _this.availableWallet = _wallet;
                        _this.render();
                    }
                },
                error: function (error) {
                }
            });

        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',

                useCreditsCheck: '#use_credits',
                tdsCheck: '#is_3ds',
                tdsContainer: '#3ds-container',

                purchaseButton: '#complete-purchase-button'
            };
        },

        events: {
            'click @ui.purchaseButton': 'purchaseButtonClicked'
        },

        regions: function() {
            return {
                CreditCardsContainer: ".credit-card-list",
                InstallmentsContainer: ".installments-container"
            };
        },

        onRender: function () {
            this.ui.select2Input.select2();

            this.ui.useCreditsCheck.prop("disabled", App.context.hasBasketRecurringProduct);

            this.creditCardsCollection = new CreditCardsCollection();
            this.creditCardsView = new CreditCardsView({
                collection: this.creditCardsCollection
            });


            this.listenTo(this.creditCardsView, 'credit-card-created', this.makePurchase.bind(this));
            this.listenTo(this.creditCardsView, 'credit_card', this.creditCardSelected.bind(this));
            this.listenTo(this.creditCardsView, 'bin_number_changed', this.binNumberChanged.bind(this));


            if (this.totalPrice > 1) {
                // Show credit card view only if payment required
                this.CreditCardsContainer.show(this.creditCardsView);
                this.InstallmentsContainer.show(this.installmentOptionsView);
            }

            // Check tds status parameter
            var tdsStatus = App.utils.getUrlParameter('tds_status');
            if (tdsStatus) {
                if (tdsStatus === '1') {
                    var _this = this;


                    setTimeout(function () {
                        App.context.redirect('/licenses');
                        _this._triggerTransactionSuccessful();
                    }, 3000);

                    App.utils.showMessage('success', App.polyglot.t('purchase_success'));
                } else if (tdsStatus === '0') {
                    App.utils.showMessage('error', App.polyglot.t('purchase_failure'));
                }
            }
        },

        templateHelpers: function(){
            return {
                totalPrice: this.totalPrice,
                totalTRY: App.utils.getBasketTotal(App.context.basket, 'TRY'),
                totalTRYWVat: App.utils.getBasketTotal(App.context.basket, 'TRY_VAT'),
                pricingMode: App.utils.getPricingMode(),
                currency: App.utils.getPaymentCurrency(),
                availableWallet: this.availableWallet,
            };
        },

        creditCardSelected: function() {
            var parameters;
            if (this.creditCardsView.selectedCreditCard === 'new') {
                parameters = {
                    bin_number: this.creditCardsView.currentBin
                };
            } else {
                parameters = {
                    card_id: this.creditCardsView.selectedCreditCard
                };
            }

            this._getInstallmentOptions(parameters);
            this._getCreditCardOptions(parameters);
        },

        binNumberChanged: function() {
            this._getInstallmentOptions({
                bin_number: this.creditCardsView.currentBin
            });
            this._getCreditCardOptions({
                bin_number: this.creditCardsView.currentBin
            });

        },

        _getInstallmentOptions: function(parameters) {
            if (parameters.hasOwnProperty('bin_number') && (!parameters.bin_number || parameters.bin_number.length < 6)) {
                //this._updateInstallmentOptions([{
                //    installment: 1,
                //    cost_percentage: 0
                //}]);
                this._updateInstallmentOptions(null);
            } else {
                // Get installment options from API
                var _this = this;
                $.ajax({
                    url: App.Config.apiBase + 'credit-cards/installment_options/',
                    method: 'get',
                    data: parameters,
                    success: function (response) {
                        if (response.installment_options) {
                            _this._updateInstallmentOptions(response.installment_options);
                        } else {
                            _this._updateInstallmentOptions(null);
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        _this._updateInstallmentOptions(null);
                    }
                });
            }
        },

        _updateInstallmentOptions: function(options) {
            this.installmentOptionsView.installmentOptions = options;
            this.installmentOptionsView.pricingDetails = {
                price: App.utils.getBasketTotal(App.context.basket, App.utils.getPricingMode()),
                currency: App.utils.getPaymentCurrency()
            };
            this.installmentOptionsView.render();
        },

        purchaseButtonClicked: function () {
            if (this.totalPrice > 1) {
                if (this.creditCardsView.selectedCreditCard) {
                    this.makePurchase(this.creditCardsView.getSelectedCreditCard());
                } else {
                    // If no credit card selected but sambapos credits used, proceed without credit card
                    if (this.ui.useCreditsCheck && this.ui.useCreditsCheck.prop('checked')) {
                        this.makePurchase(null);
                    }
                }
            } else {
                // No payment required, do not send credit card
                this.makePurchase(null);
            }
        },

        makePurchase: function (creditCard) {
            var _this = this;

        

            var purchase = new PurchaseModel({
                basket: {products: this.regularProducts},
                credit_card: creditCard,
                use_credits: (this.ui.useCreditsCheck ? this.ui.useCreditsCheck.prop('checked') : false),
                is_3d: this.tdsCheckOption || this.ui.tdsCheck.prop('checked'),
                installments: this.installmentOptionsView.selectedInstallment.toString()
            });

            var recurringPurchase = new RecurringPurchaseModel({
                basket: {products: this.recurringProducts},
                credit_card: creditCard,
            });


            if (!this.ui.purchaseButton.hasClass('loading')) {
                this.ui.purchaseButton.addClass('loading');

                if(this.regularProducts.length > 0){
                    this.regularPurchaseCompleted = false;
                    purchase.save(null, {
                        success: function (model, response, options) {
                            if (response.is_3ds) {
                                if (response.tds_html) {
                                    // Open 3DS view
                                    //$('body').append('<iframe id="tds_frame"></iframe>');
                                    //$('#tds_frame').html(atob(response.tds_html));
                                    $('body').append('<iframe id="tds_frame"   style="position: fixed;top: 0px;right: 0px;width: 100%;border: none;overflow: hidden;z-index: 999999;height: 100%;"></iframe>');
                                    $('#tds_frame').attr("srcdoc", atob(response.tds_html));

                                } else if (response.tds_redirect_url) {
                                    // Redirect to 3ds url
                                    window.location.replace(response.tds_redirect_url);
                                }
                            } else {
                                _this.regularPurchaseCompleted = true;
                                _this._completedSuccessfully();
                            }
                        },
                        error: function (model, response, options) {
                            _this.ui.purchaseButton.removeClass('loading');

                            // Show error messages
                            if (response.responseJSON.errors) {
                                for (var i=0; i<response.responseJSON.errors.length; i++) {
                                    App.utils.showMessage('error', response.responseJSON.errors[i].message);
                                }
                            }
                        }
                    });
                }

                if(this.recurringProducts.length > 0){
                    this.recurringPurchaseCompleted = false;
                    recurringPurchase.save(null, {
                        success: function (model, response, options) {
                            _this.recurringPurchaseCompleted = true;
                            _this._completedSuccessfully();
                            
                        },
                        error: function (model, response, options) {
                            _this.ui.purchaseButton.removeClass('loading');

                            // Show error messages
                            if (response.responseJSON.errors) {
                                for (var i=0; i<response.responseJSON.errors.length; i++) {
                                    App.utils.showMessage('error', response.responseJSON.errors[i].message);
                                }
                            }
                        }
                    });
                }
            }
        },

        _completedSuccessfully: function() {
            if(this.regularPurchaseCompleted && this.recurringPurchaseCompleted){
                // Transaction successful
                this.ui.purchaseButton.removeClass('loading');

                var starterPackPurchased = (App.context.basket.get('products').filter(function (storeProduct) {
                    return storeProduct.product.license_name == 'ResellerStarterPack';
                }).length > 0);
                
                

                App.context.redirect('/licenses');
                this._triggerTransactionSuccessful();
                
                App.utils.showMessage('success', App.polyglot.t('purchase_success'));
                
                if (starterPackPurchased) {
                    // If starter pack purchased, reload the page to get the menu reset
                    window.setTimeout(function () {
                        window.location.reload();
                    }, 3000);
                }
            }
        },

        _triggerTransactionSuccessful: function(){
            window.setTimeout(function () {
                App.vent.trigger('transaction-successful-clear-basket');
            }, 1000);
        },

        _getCreditCardOptions: function (parameters) {
            // Get credit card options from API
            var _this = this;
            $.ajax({
                url: App.Config.apiBase + 'credit-cards/card_options/',
                method: 'get',
                data: parameters,
                success: function (response) {
                    _this._updateCardOptions(response);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    _this._updateCardOptions(null);
                }
            });
        },

        _updateCardOptions: function (options) {
            var tdsContainerStatus = this.ui.tdsContainer.hasClass('d-none');
            if (options) {
                if (options.tds && tdsContainerStatus) {
                    this.ui.tdsContainer.removeClass('d-none');
                    if (options.local_card) {
                        this.tdsCheckOption = true;
                        this.ui.tdsCheck.prop("checked", true);
                        this.ui.tdsCheck.prop("disabled", true);
                      }
                } else if (!tdsContainerStatus) {
                    this.ui.tdsContainer.addClass('d-none');

                }
            } else {
                // set defaults
                if (!tdsContainerStatus) {
                    this.ui.tdsContainer.addClass('d-none');
                }
            }
        }
    });
});
